module.exports = {"releasedOn":"2026-10-27T15:06:12Z","version":"1.0.669","env":"dev"}


//////////////////
// WEBPACK FOOTER
// ./version.json
// module id = LdEQ
// module chunks = 1